<script lang="ts">
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import { tw } from "@core/utils/svelte/tw.js";

	const { children, class: customClass }: { children: Snippet; class?: ClassValue } = $props();

	const iphoneSafePaddingBottom = tw("pb-[max(env(safe-area-inset-bottom,0),0.5rem)]");
</script>

<div
	class={[
		"flex justify-center sm:justify-end items-center",
		"pointer-events-none inset-x-0 fixed bottom-0 z-40 gap-4 px-4 sm:px-6",
		iphoneSafePaddingBottom,
		customClass,
	]}
>
	{@render children()}
</div>
